export enum VpStatus {
  ECU_DEPENDENCY_LOAD_NEEDED = '2',
}
